export function selectAllIds(ids) {
  return (ids || []).reduce((m, id) => ((m[id] = true), m), {});
}

export function invertSelection(allIds, selected) {
  return (allIds || []).reduce((m, id) => {
    if (!selected?.[id]) m[id] = true;
    return m;
  }, {});
}
